import { Outlet } from 'react-router-dom';

import { VisitorLayout } from 'components/visitors-layout';
import { useFieldMetadata } from 'store/ui-metadata/hooks';
import { useSelector } from 'react-redux';
import { uiMetadata } from 'store/ui-metadata/selectors';

/**
 * Layout component for visits routes
 * Conditionally wraps child routes with VisitorLayout based on view_visits_enabled feature flag
 * Uses Outlet to render nested routes
 */
export const VisitsLayout = (): JSX.Element | null => {
  const viewVisitsEnabled = useFieldMetadata('view_visits_enabled');
  const uiMetadataState = useSelector(uiMetadata);

  if (!uiMetadataState) {
    return null;
  }

  // Conditionally wrap with VisitorLayout based on feature flag
  // Using conditional rendering instead of variable assignment prevents remounts
  if (viewVisitsEnabled) {
    return (
      <VisitorLayout>
        <Outlet />
      </VisitorLayout>
    );
  }

  // Create-only mode: no layout wrapper
  return <Outlet />;
};
